const Heading = ({title}) => {
  return (
    <>
            <h4 className="">{title}</h4>
    </>
  );
};
export default Heading;
